module.exports = __webpack_public_path__ + "static/media/pic_2.24ba77b4.png";